import{k as r,m as t}from"./chunk-HBP5N4FR.js";t();var c=e=>e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=/g,""),g=e=>c(r.Buffer.from(e,"utf8").toString("base64"));export{g as a};
//# sourceMappingURL=chunk-FJTOBBI5.js.map
